import styled from 'styled-components';
import { gray45, screenXsMax, spacer4 } from '@spotify-internal/encore-foundation';
export default styled.span.withConfig({
  displayName: "Optional",
  componentId: "jwmmgk-0"
})(["color:", ";padding-left:", ";@media (max-width:", "){flex:1;}"], gray45, spacer4, screenXsMax);